import { render } from "./NoSuchPage.vue?vue&type=template&id=d025f880"
import script from "./NoSuchPage.vue?vue&type=script&lang=js"
export * from "./NoSuchPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__